const GET_ASSET_EONE_DETAILS = 'GET_ASSET_EONE_DETAILS'
const SET_ASSET_EONE_DETAILS = 'SET_ASSET_EONE_DETAILS'

const GET_ASSET_AUDIT_REPORT_DETAILS = 'GET_ASSET_AUDIT_REPORT_DETAILS'
const SET_ASSET_AUDIT_REPORT_DETAILS = 'SET_ASSET_AUDIT_REPORT_DETAILS'

export {
    GET_ASSET_EONE_DETAILS,
    SET_ASSET_EONE_DETAILS,
    GET_ASSET_AUDIT_REPORT_DETAILS,
    SET_ASSET_AUDIT_REPORT_DETAILS
}